import { useEffect } from "react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { ShareButton } from "@/components/site/ShareButton";
import { MaskLines, Overline, Reveal } from "@/components/site/Primitives";
import { PostCard } from "@/components/site/PostCard";
import { useT } from "@/lib/i18n";
import { posts } from "@/lib/posts";
import { useSeo } from "@/lib/seo";

export default function BlogPage() {
  const t = useT().blog;
  useSeo({ title: t.seoTitle, description: t.seoDesc });
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const [first, ...rest] = posts;

  return (
    <div className="site" id="top">
      <div className="grain" aria-hidden="true" />
      <Nav />
      <main className="pt-32 md:pt-40 pb-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <Overline>{t.over}</Overline>
          <h1 className="mt-8 font-display font-light leading-[0.98] tracking-[-0.02em] text-[13vw] sm:text-7xl lg:text-[6.5rem]" data-testid="blog-title">
            <MaskLines lines={t.title} italicIndex={1} delay={0.1} />
          </h1>
          <Reveal delay={0.3}><p className="mt-8 max-w-2xl text-base md:text-lg text-stone-300">{t.sub}</p></Reveal>
          <Reveal delay={0.2} className="mt-16"><PostCard post={first} big /></Reveal>
          <div className="mt-6 grid md:grid-cols-3 gap-6">
            {rest.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.1} className="h-full"><PostCard post={p} /></Reveal>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <ShareButton />
    </div>
  );
}
